import SysColumn from "app/class/sys-column";

export const isRecordFieldReadOnly = (column: SysColumn, tableName: string) =>
    Boolean(column.is_read_only) || (column.name === "number_ref" && tableName !== "sys_tables");
